import type {PreparedBlock} from '@github-ui/taillights-worker/document'
import {createContext, use, type RefObject} from 'react'
import type {TaillightRenderer} from './taillight-types'

export type TaillightBlockContext = {
  block: PreparedBlock
  nativeSourceRef: RefObject<HTMLElement | null>
  renderer: TaillightRenderer
  inert: boolean
  isSelectable: boolean
  hidePaint: boolean
}

export const TaillightContext = createContext<TaillightBlockContext | null>(null)

export function useTaillightContext(): TaillightBlockContext {
  const context = use(TaillightContext)
  if (!context) throw new Error('useTaillightContext must be used inside a Taillight.')
  return context
}
